import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Collapsible from 'global/Collapsible';
import {
  formatBondCurrency,
  formatBondDate,
} from 'features/securities/withdrawal/utils';

interface Props {
  date: string;
  amount: number;
  accruedInterest?: number;
  sellerCoupon?: number;
}

export default function HistoryRowItem({
  date,
  amount,
  accruedInterest,
  sellerCoupon,
}: Props) {
  const headerElement = (
    // @ts-expect-error
    <Flex p="8px 0px" justify="space-between" align="center" width="100%">
      <Text size="14px">{formatBondDate(new Date(date))}</Text>
      <Text size="14px">{formatBondCurrency(amount)}</Text>
    </Flex>
  );

  if (sellerCoupon <= 0) {
    return <>{headerElement}</>;
  }

  return (
    <Collapsible header={headerElement} expandDirection="bottom">
      {/* @ts-expect-error */}
      <Flex justify="space-between" align="center" width="100%" mb="8px">
        <Text color="#858585" size="14px">
          Kupon Hak Kamu
        </Text>
        <Text color="#858585" size="14px">
          {formatBondCurrency(accruedInterest)}
        </Text>
      </Flex>
      <Flex justify="space-between" align="center" width="100%">
        <Text color="#858585" size="14px">
          Kupon Penjual
        </Text>
        <Text color="#858585" size="14px">
          {formatBondCurrency(sellerCoupon)}
        </Text>
      </Flex>
    </Collapsible>
  );
}
